import { UserForum } from "./user.model";
export class Topic {
  constructor(
    public courseId?: string,
    public deletedAt: string = "",
    public description: string = "",
    public id: string = "",
    public likes: Like = new Like(),
    public media:MediaForum=  new MediaForum(),
    public tag: string = "",
    public title: string = "",
    public userAuthor: UserForum = new UserForum(),
    public likeAmount: number = 0,
    public commentAmount: number = 0,
    public status?: StatusTopic,
    public createdAt?: Date,
    public userLiked: boolean = false,
    public mediaId?: string
  ) { }
}

export class MediaForum {
  constructor(
    public likeAmount: Like = new Like(),
    public commentAmount: string = "",
    public tag: string = "",
    public title: string = "",
    public userAuthor: UserForum = new UserForum(),
    public status: StatusTopic = StatusTopic.ACTIVE,
    public createdAt: Date = new Date(),
    public userLiked: boolean = false,
    public chapterName: string = "",
    public courseName: string = "",
    public duration: number = 0,
    public id: string = "",
    public learningObjectId: string = "",
    public learningObjectName: string = "",
    public mimetype: string = "",
    public name: string = "",
    public path: string = "",
    public referenceTranscript: string = "",
    public secure: boolean = true,
    public transcriptId: string = "",
    public url: string = "",
  ) {}
}
export class Like {
  constructor(
    public id: string = "",
    public userCreated: UserForum = new UserForum()
  ) {}
}

export enum StatusTopic {
  ACTIVE = "ACTIVE",
  CLOSED = "CLOSED",
  SOLVED = "SOLVED",
}

